import { API_URL, ACTIONS, HTTP_METHODS } from "UTILS/Constants";
import BaseAction from "CONFIG/BaseAction";

export class WaitingUsersAction extends BaseAction {
  constructor() {
    super();
    BaseAction.call(this);
  }

  // never make this function as arrow function
  getSessionWaitListAction(requestBody) {
    return new Promise((resolve, reject) => {
      this.callApi({
        httpMethod: HTTP_METHODS.GET,
        url: `${API_URL.GET_SESSION_WAIT_LIST}`,
        requestBody
      }).then(
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  setWaitingUsersData(waitingUsersData) {
    this.dispatch({
      type: ACTIONS.SET_WAITING_USERS_DATA,
      waitingUsersData
    });
  }
}
